import Carousel from 'react-bootstrap/Carousel';

const MinCarousel = () => {
    return (
        <div className="carousel">
            <Carousel interval={1000} keyboard={false} pauseOnHover={true} fade>
                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img1.jpg'} />
                    {/* <Carousel.Caption>
                        <p className='carousel-caption white-chocolate heading-2'>We give life to the design</p>
                    </Carousel.Caption> */}
                </Carousel.Item>

                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img2.jpg'} />
                </Carousel.Item>

                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img3.jpg'} />
                </Carousel.Item>
                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img4.jpg'} />
                </Carousel.Item>
                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img5.jpg'} />
                </Carousel.Item>
                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img6.jpg'} />
                </Carousel.Item>
                <Carousel.Item >
                    <img className="d-block w-100 carousel-img"
                        src={'assets/images/carousel/img7.jpg'} />
                </Carousel.Item>

            </Carousel>
        </div>
    );
}

export default MinCarousel;